"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  attach: function attach() {},
  detach: function detach() {}
};


//////////////////
// WEBPACK FOOTER
// ./~/focus-lock/dist/cjs/tabHook.js
// module id = 1766
// module chunks = 0